<template>
  <v-layout fill-height column>
    <v-container>
      <div class="solution-timer-controller">
        <div class="left"></div>
        <div class="time">{{ resTimeData }}</div>
        <div class="right">
          <v-btn icon class="btn-play" @click="control">
            <Play :play="play"/>
          </v-btn>
        </div>
      </div>
    </v-container>
    <div class="question" v-html="ques[0]"></div>
    <div class="answer">
      <draggable v-model="answer" draggable="false">
        <div class="pos-relative mb-4" v-for="n in replyArr.length" :key="n">
          <div v-touch="{
                                left: () => swipe('Left',n-1),
                                right: () => swipe('Right',n-1),
                            }"
               class="swipe"
               :class="{'swipe-left':swipeDirection[n-1] === 'Left','swipe-right':swipeDirection[n-1] === 'Right'} "
          >
                        <Textarea v-model="answer[n-1].textarea"
                                  :height="140"
                                  :counter="500"
                                  :placeholder="answer[n-1].reply"
                                  class="textarea"
                                  ref="textArea"
                                  :readonly="readOnly"
                        />
          </div>
          <v-btn depressed plain class="swipe-btn-delete" @click="textareaDelete(n-1)">삭제</v-btn>
        </div>
      </draggable>
      <div class="text-center">
        <v-btn v-if="!readOnly && this.replyCnt > answer.length" depressed plain class="btn-add" @click="btnAdd">+ 추가
          작성하기
        </v-btn>
      </div>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import Play from '@/components/icons/Play'
import draggable from 'vuedraggable'
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  components: {
    Play,
    draggable,
    Textarea,
    FooterBtnsNext,
  },
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyArrTmp: [],
    replyObjArr: [],
    replyObjArrTmp: [],
    userReplyNo: [],
    userReply: [],
    answer: [],
    swipeDirection: [],
    replyCnt: 0,

    play: false,
    time: '',
    min: 0,
    sec: 0,
    timeCounter: 0,
    resTimeData: '',
  }),
  computed: {
    readOnly() {
      // if(this.cmplt || this.timeCounter <= 0){ //요청으로 인해 시간 제한지나도 입력가능
      if (this.cmplt) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.textarea = '',
        this.disabledNext = true,
        this.free = 'N',
        this.cmplt = false,
        this.ques = [],
        this.replyArr = [],
        this.replyArrTmp = [],
        this.replyObjArr = [],
        this.replyObjArrTmp = [],
        this.userReplyNo = [],
        this.userReply = [],
        this.answer = [],
        this.swipeDirection = [],
        this.replyCnt = 0,
        this.play = false,

        this.timeStop()
      this.play = false,
        this.time = 0
      this.min = 0
      this.sec = 0
      this.timeCounter = 0

      this.getUnitTime()
    },
    answer: {
      handler: function () {
        for (let len = 0; len < this.answer.length; len++) {
          if (this.answer[len].textarea != undefined && this.answer[len].textarea.trim() != '' && this.answer[len].textarea.length <= 500) {
            this.disabledNext = false
          } else {
            this.disabledNext = true
            break
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
  },
  mounted() {
    // this.getUnitDetailUse()
    this.getUnitTime()
  },
  methods: {
    async getUnitTime() {
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo}
          , {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]}
          , {'unitDtlPageSeq': 1}
          , {'freeYn': this.freeYn}
          , {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success && res.data.unitDtlQuesList != null) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {

              // 시간 조회
              if (quesEl.timeType == '02') {
                // 관리자에서 설정한 값
                this.time = quesEl.timeSet
              } else {
                // 사용자 답변에서 조회
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {
                  this.time = userReplyEl.reply
                });
              }
            });

            this.min = this.time.substr(0, 2)
            this.sec = this.time.substr(2, 2)
            this.timeCounter = (parseInt(this.min) * 60) + parseInt(this.sec)

            this.getUnitDetailUse()
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)
              this.replyCnt = quesEl.replyCnt

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl, k) => {

                this.swipeDirection.push('Right')

                if (k < 1) {
                  this.replyArr.push(replyEl.reply)
                  // this.replyArrTmp.push(replyEl.reply)
                  this.replyObjArr.push(replyEl)
                  this.answer.push(replyEl)
                } else {
                  this.replyArrTmp.push(replyEl.reply)
                  this.replyObjArrTmp.push(replyEl)
                  // this.answer.push(replyEl)
                }
              });

              // 유저 답변 셋팅
              if (quesEl.memberUnitDtlReplyList.length > 0) {
                // 답변 비우고
                this.answer.splice(0, this.answer.length);

                quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                  this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                  userReplyEl.textarea = userReplyEl.reply
                  if (j < 1) {
                    userReplyEl.reply = this.replyArr[j]
                  } else {
                    userReplyEl.reply = this.replyArrTmp[0]
                    this.replyArr.push(this.replyArrTmp[0])
                    this.replyArrTmp.shift()
                    this.replyObjArr.push(userReplyEl)
                    this.replyObjArrTmp.shift()
                  }
                  this.answer.push(userReplyEl)
                });
              }
            });
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
          this.start()
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.answer.forEach((replyObj, i) => {
          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: 0,
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: replyObj.textarea,
            // score: replyObj.score,
            freeYn: this.free,
            unitType: "08",
          }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    control() {
      this.play = !this.play;

      if (this.play) {
        this.timeStop()
      } else {
        this.reStart()
      }
    },
    start() {
      // 1초에 한번씩 start 호출
      this.polling = setInterval(() => {
        // this.timeCounter-- //1 감소
        this.resTimeData = this.prettyTime()
        this.timeCounter-- //1 감소


        if (this.timeCounter < 0) this.timeStop()

      }, 1000)
    },
    // 시간 형식으로 변환 리턴
    prettyTime() {
      let time = this.timeCounter / 60
      let minutes = parseInt(time)
      let secondes = Math.round((time - minutes) * 60)
      return this.pad(minutes, 2) + ":" + this.pad(secondes, 2)
    },
    // 2자리수로 만들어줌 09,08...
    pad(n, width) {
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    timeStop() {
      clearInterval(this.polling)
    },
    // 재실행
    reStart() {
      clearInterval(this.polling)
      this.start()
    },
    swipe(direction, flag) {
      this.swipeDirection.splice(flag, 1);
      this.swipeDirection.splice(flag, 0, direction);
    },
    textareaDelete(val) {

      if (!this.readOnly && this.answer.length > 1) {
        // tmp에 삽입
        this.answer[val].textarea = ''
        this.answer[val].score = 0
        this.replyArrTmp.push(this.replyArr[val])
        this.replyObjArrTmp.push(this.answer[val])

        // 삭제
        this.answer.splice(val, 1);
        this.replyArr.splice(val, 1);
        this.swipe('Right', val)
      }
    },
    btnAdd() {
      this.replyArr.push(this.replyArrTmp[0])
      this.replyArrTmp.shift()

      this.answer.push(this.replyObjArrTmp[0])
      this.replyObjArrTmp.shift()
    },
  },
}
</script>
